<template>
<div>
  <vs-card class="cstm_vx_card">
    <vs-row vs-justify="space-between" slot="header">
      <h4>Language</h4>
      <vs-button
      v-if="checkEditPermission()"
        type="border"
        color="primary"
        style="font-size: 13.8px; padding: 7px; float: right;"
        @click="addpopup = true"
      >
        Add
      </vs-button>
      </vs-row>

      <div class="vx-row">
        <vs-table :data="languageProps" class="cstm_vuexy_table w-full">
          <template slot="thead">
            <vs-th sort-key="name">Language</vs-th>
            <vs-th sort-key="date">Sort Name</vs-th>
            <vs-th sort-key="status" style="width: 250px;">Action</vs-th>
          </template>

          <template>
            <vs-tr :key="indextr" v-for="(item, indextr) in languageProps">
              <vs-td :data="languageProps[indextr].language">
                {{ languageProps[indextr].language }}
              </vs-td>
              <vs-td :data="languageProps[indextr].short_name">
                {{ languageProps[indextr].short_name }}
              </vs-td>
              <vs-td :data="languageProps[indextr]">
                <vs-row vs-type="flex">
                  <vs-button color="primary" v-if="checkEditPermission()" type="filled" icon="edit" class="mr-2" @click="handleedit(indextr)"/>
                  <vs-button type="filled" v-if="checkDeletePermission()" @click="remove(indextr)" icon="delete" color="danger"/>
                </vs-row>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vs-card>


    <vs-popup classContent="popup-example"  title="Delete" :active.sync="deletepopup">
      <h4>Are you sure to delete this ?</h4>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
        <vs-button class="mr-2" @click="handleDelete">Confirm</vs-button>
        <vs-button type="border" color="danger" @click="deletepopup = false">Cancel</vs-button>
      </vs-row>
    </vs-popup>


    <vs-popup classContent="popup-example"  title="Add Language" :active.sync="addpopup">
      <form data-vv-scope="add">
        <vs-row>
          <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
            <v-select v-validate="'required'" name="language" :options="languageList" v-model="language" label="language" :reduce="item => item" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
            <span v-show="errors.has('edit.language')" class="text-danger">{{ errors.first('edit.language') }}</span>
          </vs-col>
        </vs-row>
      </form>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
        <vs-button class="mr-2" @click.prevent="handleSave">Save</vs-button>
        <vs-button type="border" color="danger" @click="addpopup  = false">Cancel</vs-button>
      </vs-row>
    </vs-popup>


    <vs-popup classContent="popup-example"  title="Edit Language" :active.sync="editpopup">
      <form data-vv-scope="edit">
        <vs-row>
          <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
            <v-select v-validate="'required'" name="language" :options="languageList" :value="item => item.id" label="language" v-model="edit" :reduce="item => item" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
            <span v-show="errors.has('edit.language')" class="text-danger">{{ errors.first('edit.language') }}</span>
          </vs-col>
        </vs-row>
      </form>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
        <vs-button class="mr-2" @click.prevent="handleUpdate">Save</vs-button>
        <vs-button type="border" color="danger" @click="editpopup = false">Cancel</vs-button>
      </vs-row>
    </vs-popup>
</div>
</template>
<script>
import {GetLanguageList} from '@/api/common'
import vSelect from 'vue-select'
import { PermissionMiddleware } from '@/mixins/middleware/PermissionMiddleware'
import {  TeacherUpdate } from '@/api/teacher'

export default {
  name: 'email',
  components: {
    vSelect
  },
  created () {
    const role_permission = localStorage.getItem('role_permission')
    if (role_permission == 1) {
      this.schoolAdmin = true
    } else {
      this.schoolAdmin = false

      this.getModulePermission('Teachers')
    }
  },
  mixins: [PermissionMiddleware],
  props: {
    languageProps: {
      required: true,
      type: Array,
      default: () => []
    }
  },
  watch:{
    languageProps:{
      deep:true,
      immediate:true,
      handler () {
        this.languageAvailability = this._.cloneDeep(this.languageProps)
      }
    }
  },
  data () {
    return {
      languageAvailability:[],
      addpopup: false,
      deletepopup:false,
      editpopup: false,
      language: {
        created_at: null,
        deleted_at: null,
        id: null,
        language: null,
        short_name: null,
        updated_at: null
      },
      edit: {
        created_at: null,
        deleted_at: null,
        id: null,
        language: null,
        short_name: null,
        updated_at: null
      },
      editIndex: null,
      deleteindex: false,
      languageList:[]
    }
  },

  mounted () {
    this.getLanguage()
  },
  computed: {
    /* languageAvailability: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    } */
  },
  methods: {
    handleSave () {
      this.$validator.validateAll('add').then(result => {
        if (result) {
          const payload = this.language
          this.languageAvailability.push(payload)
          this.addpopup = false
          this.language = {
            created_at: null,
            deleted_at: null,
            id: 1,
            language: null,
            short_name: null,
            updated_at: null
          }
          this.handleLanguageSave()
        }
      })

    },
    async handleLanguageSave () {
      try {
        const customer_id = localStorage.getItem('customer_id')
        const __temp = this.languageAvailability.map(item => item.id)
        const finalLanguages = {
          platform_languages_id: __temp
        }
        const payload = {
          updateField: {
            languages: finalLanguages
          }
        }
        const {data} = await TeacherUpdate(
          payload,
          this.$route.params.teacher_id,
          customer_id
        )
        // this.setAfterUpdate(data)
        this.addpopup = false
        this.editpopup  = false
        this.deletepopup = false


        this.$emit('setAfterUpdate', data)
        // this.fetchTeacherDetails(this.$route.params.teacher_id)
        // this.bioEditPopup = false
        this.showSuccessMessage('Success', 'Updated Successfully', 'success')

      } catch (error) {
        console.log(error)
        this.showSuccessMessage('Error', error.data.message, 'danger')
      }
    },
    handleedit (index) {
      this.editpopup = true
      
      this.edit = this.languageAvailability[index]
      this.editIndex =  index
    },
    handleUpdate () {
      this.$validator.validateAll('edit').then(result => {
        if (result) {
          const __temp = this.languageAvailability
          __temp[this.editIndex] = this.edit
          this.languageAvailability = __temp
        }
        this.handleLanguageSave()
      })

    },
    handleDelete () {
      this.languageAvailability.splice(this.deleteindex, 1)
      this.handleLanguageSave()
      
    },
    remove (index) {
      if (this.languageAvailability.length > 1) {
        this.deletepopup = true
        this.deleteindex = index
      } else {
        this.$vs.notify({
          title: 'warning',
          text: 'Minimum one language must be add',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
      }

    },
    async getLanguage () {
      try {
        const { data } = await GetLanguageList()
        const list = data.data.languages_list
        // list.map(item => {
        //   return {
        //     id:item.id,
        //     language:item.language,
        //     short_name: item.short_name
        //   }
        // })
        this.languageList = list
        
      } catch (e) {
        
      }
    }
  }
}
</script>
